import axios from 'axios';

const API_URL = '/api/v1';

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

export const getFriendships = async (token) => {
  const response = await axios.get(`${API_URL}/friendships`, {
    headers: authHeaders(token)
  });
  return response.data;
};

export const sendFriendRequest = async (receiverId, token) => {
  const response = await axios.post(`${API_URL}/friendships`,
    { receiver_id: receiverId },
    { headers: authHeaders(token) }
  );
  return response.data;
};

export const respondToRequest = async (friendshipId, status, token) => {
  const response = await axios.patch(`${API_URL}/friendships/${friendshipId}`,
    { status },
    { headers: authHeaders(token) }
  );
  return response.data;
};

export const removeFriendship = async (friendshipId, token) => {
  await axios.delete(`${API_URL}/friendships/${friendshipId}`, {
    headers: authHeaders(token)
  });
};

export const searchUsers = async (query, token) => {
  const response = await axios.get(`${API_URL}/users/search`, {
    params: { q: query },
    headers: authHeaders(token)
  });
  return response.data;
};
